import angular from "angular";

import { ChatwootAdapter } from "../../presentation/adpters/ChatwootAdapter/ChatwootAdapter";

export class ChatAtendimentoService {
    constructor() {
        this.openned = false;
        this.origem = null;
        this.ChatwootAdapter = new ChatwootAdapter();
    }

    /** `origem` vai para a conversa ("campanha:<id>"), para o atendente saber de onde a pessoa veio. */
    open(origem) {
        this.openned = true;
        this.origem = origem ?? null;
        this.ChatwootAdapter.open(this.origem);
    }

    isDisponivel() {
        return this.ChatwootAdapter.isVisivel();
    }

    /** Disponível e com o widget carregado: o `open()` abre de fato. */
    isPronto() {
        return this.ChatwootAdapter.isPronto();
    }

    toMaintain() {
        const body = angular.element(document.querySelector("body"));

        if (!this.openned) return body.removeClass("overwrite-chat-rules");

        // Reabre a MESMA conversa: a origem com que ela foi aberta continua.
        this.ChatwootAdapter.open(this.origem);
        this.openned = false;
    }

    hide() {
        const body = angular.element(document.querySelector("body"));
        body.addClass("hide-chat-module");
    }

    show() {
        const body = angular.element(document.querySelector("body"));
        body.removeClass("hide-chat-module");
    }
}

angular
    .module("nucont.shared")
    .service("ChatAtendimentoService", [ChatAtendimentoService]);
